import React, { useEffect, useState } from 'react';
import PageApp from '../../../Page';
import RangoEmpleadosInput, { RangoEmpleadosLabel } from '../../../../utils/RangoEmpleadosInput';
import { HomeOutlined, UnorderedListOutlined, FileTextOutlined } from '@ant-design/icons';
import { Form, Divider, Button, Select, Row, Col, Card, Space, message } from 'antd';
import AnioPreNomina from '../../../../components/forms/anio_prenomina';
import { getList as getHorarios } from '../../../../apis/OdooScheduleApi';
import { getList as getDepartamentos } from '../../../../apis/OdooDepartamentoApi';
import { getList as getPuestos } from '../../../../apis/OdooPuestoApi';
import { getList as getAreas } from '../../../../apis/AreasTrabajoApi';
import { getAll as getSupervisores } from '../../../../apis/SupervisoresApi';
import { generarExcelHorasAnalitica } from '../../../../apis/ProcesoPreNominaApi';

const { Option } = Select;

const routes = [
    {
        href: '',
        title: <>
            <HomeOutlined />
            <span>Inicio</span>
        </>,
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Asistencia</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Reportes</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <FileTextOutlined />
                <span>Reporte de Tiempo Ordinario</span>
            </>
        ),
    }
];

const ReporteTiempoOrdinarioPage = () => {
    const [form] = Form.useForm();
    const [formFilters] = Form.useForm();
    const [period, setPeriod] = useState(null);
    const [anio, setAnio] = useState(null);
    const [disabledForm, setDisabled] = useState(true);
    const [loadingExcel, setLoadingExcel] = useState(false);

    // Estados para los catálogos
    const [horarios, setHorarios] = useState([]);
    const [puestos, setPuestos] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [areas, setAreas] = useState([]);
    const [supervisores, setSupervisores] = useState([]);

    useEffect(() => {
        (async () => {
            await getCatalogs();
        })();
    }, []);

    const getCatalogs = async () => {
        const responseHorarios = await getHorarios();
        if (responseHorarios.ok) {
            setHorarios(responseHorarios.payload);
        }

        const responseDepartamentos = await getDepartamentos();
        if (responseDepartamentos.ok) {
            setDepartamentos(responseDepartamentos.payload);
        }

        const responseAreas = await getAreas();
        if (responseAreas.ok) {
            setAreas(responseAreas.payload);
        }

        const responseSupervisores = await getSupervisores();
        if (responseSupervisores.ok) {
            setSupervisores(responseSupervisores.payload);
        }

        const responsePuestos = await getPuestos();
        if (responsePuestos.ok) {
            setPuestos(responsePuestos.payload);
        }
    };

    const onBlurHeader = async (values, periodData) => {
        if (values?.anio && periodData) {
            setAnio(values.anio);
            setPeriod(periodData);
            setDisabled(false);
        } else {
            setAnio(null);
            setPeriod(null);
            setDisabled(true);
            formFilters.resetFields();
        }
    };

    const validateFilters = async () => {
        const filters = await formFilters.getFieldsValue();

        // Validar que el periodo esté seleccionado
        if (!period || !anio) {
            message.warning('Debe seleccionar un periodo válido');
            return null;
        }

        // Validar rango de empleados si se proporcionó
        if (filters.empleado_rango && filters.empleado_rango.trim()) {
            const rangoPattern = /^\s*(\d+\s*-\s*\d+|\d+)(\s*,\s*(\d+\s*-\s*\d+|\d+))*\s*$/;
            if (!rangoPattern.test(filters.empleado_rango.trim())) {
                message.warning('El formato de rango de empleados no es válido. Use el formato: 1-7, 50, 150, 200-300');
                return null;
            }
        }

        // Construir el payload
        const payload = {
            periodo_id: period.periodoCompleto.periodo_id,
            anio: anio,
            num_periodo: period.num_periodo,
        };

        // Agregar filtros solo si tienen valor
        if (filters.horario_id) {
            payload.horario_id = filters.horario_id;
        }
        if (filters.puesto_id) {
            payload.job_id = filters.puesto_id;
        }
        if (filters.departamento_id) {
            payload.departamento_id = filters.departamento_id;
        }
        if (filters.area_id) {
            payload.area_id = filters.area_id;
        }
        if (filters.supervisor_id) {
            payload.supervisor_id = filters.supervisor_id;
        }

        if (filters.empleado_rango && filters.empleado_rango.trim()) {
            payload.empleado_rango = filters.empleado_rango.trim();
        }

        return payload;
    };

    const onDescargarExcel = async () => {
        try {
            const payload = await validateFilters();
            if (!payload) return;

            setLoadingExcel(true);
            const hide = message.loading('Generando Excel de horas por analítica...', 0);

            try {
                const response = await generarExcelHorasAnalitica(payload);
                
                hide();
                setLoadingExcel(false);
                if (response) {
                    message.success('Excel descargado exitosamente');
                }

            } catch (error) {
                hide();
                setLoadingExcel(false);
                console.error('Error al descargar Excel:', error);
                message.error(error.message || 'Error al descargar el Excel');
            }

        } catch (error) {
            setLoadingExcel(false);
            console.error('Error al validar:', error);
            message.error('Por favor verifique los campos');
        }
    };

    return (
        <PageApp
            routes={routes}
            title={'Reporte de Tiempo Ordinario'}
        >
            <>
                <AnioPreNomina
                    onBlur={onBlurHeader}
                    form={form}
                    disabledForm={false}
                />
                <Divider />

                <Form
                    layout="vertical"
                    form={formFilters}
                    disabled={disabledForm}
                >
                    <Card title="Filtros" style={{ marginBottom: 16 }}>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item
                                    name="horario_id"
                                    label="Horario"
                                >
                                    <Select
                                        placeholder="Selecciona un horario"
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {horarios.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.codigo_corto}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    name="puesto_id"
                                    label="Puesto"
                                >
                                    <Select
                                        placeholder="Selecciona un puesto"
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {puestos.map((item) => (
                                            <Option key={item.value} value={item.value}>
                                                {item.text}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    name="departamento_id"
                                    label="Departamento"
                                >
                                    <Select
                                        placeholder="Selecciona un departamento"
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {departamentos.map((item) => (
                                            <Option key={item.value} value={item.value}>
                                                {item.text}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item
                                    name="area_id"
                                    label="Área"
                                >
                                    <Select
                                        placeholder="Selecciona un área"
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {areas.map((item) => (
                                            <Option key={item.value} value={item.value}>
                                                {item.text}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    name="supervisor_id"
                                    label="Supervisor"
                                >
                                    <Select
                                        placeholder="Selecciona un supervisor"
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {supervisores.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item
                            name="empleado_rango"
                            label={<RangoEmpleadosLabel />}
                        >
                            <RangoEmpleadosInput />
                        </Form.Item>
                    </Card>

                    <Row>
                        <Col span={24} style={{ textAlign: 'right' }}>
                            <Space>
                                <Button onClick={() => {
                                    formFilters.resetFields();
                                }}>
                                    Limpiar
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={onDescargarExcel}
                                    disabled={disabledForm}
                                    loading={loadingExcel}
                                    style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                                >
                                    Descargar Excel
                                </Button>
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </>
        </PageApp>
    );
};

export default ReporteTiempoOrdinarioPage;